
import { bl_fm_file_ext_RowClass } from "../../../dbschema/bl_fm_file_ext.model";
import { bl_fm_file_hdr_RowClass, bl_fm_file_hdr_RowInterface } from "../../../dbschema/bl_fm_file_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class FileContainerModel extends BaseContainerModel {
  bl_fm_file_hdr: bl_fm_file_hdr_RowInterface = new bl_fm_file_hdr_RowClass();
  bl_fm_file_exts: bl_fm_file_ext_RowClass[] = [];
}
